import { State } from '@meraki-internal/state';
import { MixPanelEventEmitter } from '../../metrics/MixPanelEventEmitter';

// Where the sheet was opened from — pass-through to analytics only (never branches behavior).
export type ISharingAccessSource = 'Care Recipient Menu' | 'Community' | 'Care Map Member Detail' | 'Care Profile' | 'Linked Email Field';

// Shared open/close state for the Sharing & Access sheet so it can be opened from anywhere
// in the care map (the care recipient menu, a member's access banner, etc.) rather than from
// a single component's local useState. The sheet itself is rendered once at the care map shell.
export class SharingAndAccessState extends State {

    static inject = () => [MixPanelEventEmitter];
    constructor(private tracking: MixPanelEventEmitter) {
        super({});
    }

    isOpen = false;

    // When true, the sheet opens straight to the Add Person flow rather than the people list
    // (e.g. the "Invite" quick-add button, which is an explicit invite CTA).
    startOnAddPerson = false;

    open = (source: ISharingAccessSource, options?: { startOnAddPerson?: boolean }) => {
        if (!this.isOpen) {
            this.isOpen = true;
            this.startOnAddPerson = options?.startOnAddPerson ?? false;
            this.tracking.track('Sharing & Access Opened', () => ({ Source: source }));
            this.setState({});
        }
    };

    close = () => {
        if (this.isOpen) {
            this.isOpen = false;
            this.startOnAddPerson = false;
            this.setState({});
        }
    };
};
